<h2 mat-dialog-title class="dialog-header">
  <span>Payment Provider</span>
  <button mat-icon-button aria-label="Close" (click)="activeModal.close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content payment-provider-dialog-content mat-typography">
  <section class="payment-provider-hero">
    <div>
      <div class="payment-provider-kicker">Provider flow</div>
      <h3>{{ paymentProvider?.provider || 'Unknown provider' }}</h3>
      <p>{{ formatPhaseLabel(paymentProvider?.currentPhase) }} · {{ formatStatusLabel(paymentProvider?.status) }}</p>
    </div>
    <div class="payment-provider-hero-chips">
      <span class="pp-chip" [ngClass]="statusClass(paymentProvider?.status)">{{ formatStatusLabel(paymentProvider?.status) }}</span>
      <span class="pp-chip pp-chip--neutral">{{ formatPhaseLabel(paymentProvider?.currentPhase) }}</span>
    </div>
  </section>

  <div class="payment-provider-grid">
    <mat-card class="payment-provider-card payment-provider-card--summary">
      <h4>Resumen</h4>
      <div class="payment-provider-metrics">
        <div class="payment-provider-metric">
          <span class="payment-provider-metric-label">Total</span>
          <strong>{{ formatCurrency(paymentProvider?.total) }}</strong>
        </div>
        <div class="payment-provider-metric">
          <span class="payment-provider-metric-label">Fases</span>
          <strong>{{ paymentProvider?.phases?.length || 0 }}</strong>
        </div>
        <div class="payment-provider-metric">
          <span class="payment-provider-metric-label">Reservas</span>
          <strong>{{ paymentProvider?.reservationUuids?.length || 0 }}</strong>
        </div>
      </div>
      <div class="payment-provider-fields">
        <div class="payment-provider-field">
          <span class="payment-provider-field-label">ID</span>
          <code>{{ valueOrDash(paymentProvider?.id) }}</code>
        </div>
        <div class="payment-provider-field">
          <span class="payment-provider-field-label">Location ID</span>
          <code>{{ valueOrDash(paymentProvider?.locationId) }}</code>
        </div>
        <div class="payment-provider-field full-span">
          <span class="payment-provider-field-label">Payment UUID</span>
          <code>{{ valueOrDash(paymentProvider?.paymentUuid) }}</code>
        </div>
      </div>
    </mat-card>

    <mat-card class="payment-provider-card">
      <h4>Estado y tiempo</h4>
      <div class="payment-provider-fields">
        <div class="payment-provider-field">
          <span class="payment-provider-field-label">Estado</span>
          <span class="pp-chip" [ngClass]="statusClass(paymentProvider?.status)">{{ formatStatusLabel(paymentProvider?.status) }}</span>
        </div>
        <div class="payment-provider-field">
          <span class="payment-provider-field-label">Fase actual</span>
          <span class="pp-chip pp-chip--neutral">{{ formatPhaseLabel(paymentProvider?.currentPhase) }}</span>
        </div>
        <div class="payment-provider-field">
          <span class="payment-provider-field-label">Creado</span>
          <span>{{ formatDateTime(paymentProvider?.createdAt) }}</span>
        </div>
        <div class="payment-provider-field">
          <span class="payment-provider-field-label">Actualizado</span>
          <span>{{ formatDateTime(paymentProvider?.updatedAt) }}</span>
        </div>
      </div>
    </mat-card>

    <mat-card class="payment-provider-card">
      <h4>Fases</h4>
      <div class="payment-provider-list" *ngIf="paymentProvider?.phases?.length; else noPhases">
        <div class="payment-provider-list-item" *ngFor="let phase of paymentProvider?.phases; let i = index">
          <span class="payment-provider-list-index">{{ i + 1 }}</span>
          <span>{{ formatPhaseLabel(phase) }}</span>
        </div>
      </div>
      <ng-template #noPhases>
        <p class="payment-provider-empty">No hay fases registradas.</p>
      </ng-template>
    </mat-card>

    <mat-card class="payment-provider-card">
      <h4>Reservas vinculadas</h4>
      <div class="payment-provider-list" *ngIf="paymentProvider?.reservationUuids?.length; else noReservations">
        <div class="payment-provider-list-item" *ngFor="let reservationUuid of paymentProvider?.reservationUuids">
          <code>{{ reservationUuid }}</code>
        </div>
      </div>
      <ng-template #noReservations>
        <p class="payment-provider-empty">No hay reservas vinculadas.</p>
      </ng-template>
    </mat-card>

    <mat-card class="payment-provider-card payment-provider-card--wide">
      <h4>Identificadores externos</h4>
      <div class="payment-provider-fields">
        <div class="payment-provider-field">
          <span class="payment-provider-field-label">Payment intent</span>
          <code>{{ valueOrDash(paymentProvider?.paymentIntent) }}</code>
        </div>
        <div class="payment-provider-field">
          <span class="payment-provider-field-label">Subscription ID</span>
          <code>{{ valueOrDash(paymentProvider?.subscriptionId) }}</code>
        </div>
        <div class="payment-provider-field">
          <span class="payment-provider-field-label">Invoice ID</span>
          <code>{{ valueOrDash(paymentProvider?.invoiceId) }}</code>
        </div>
        <div class="payment-provider-field">
          <span class="payment-provider-field-label">Subscription period start</span>
          <span>{{ formatDateTime(paymentProvider?.subscriptionPeriodStart) }}</span>
        </div>
        <div class="payment-provider-field">
          <span class="payment-provider-field-label">Stripe subscription period end</span>
          <span>{{ formatDateTime(paymentProvider?.stripeSubscriptionPeriodEnd) }}</span>
        </div>
      </div>
    </mat-card>

    <mat-card class="payment-provider-card payment-provider-card--wide" *ngIf="hasEventContent()">
      <h4>Payload del evento</h4>
      <pre class="payment-provider-pre">{{ formatJson(paymentProvider?.event) }}</pre>
    </mat-card>
  </div>
</mat-dialog-content>
